import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import { useVendors } from '../hooks/useVendors'
import FormBasicInformation from '../components/vendors/form/BasicInformation'
import FormAddressInformation from '../components/vendors/form/AddressInformation'
import FormLegalityInformation from '../components/vendors/form/LegalityInformation'
import FormAdditionalInformation from '../components/vendors/form/AdditionalInformation'
import Card from 'components/card/Card'
import ButtonLink from 'components/button/Button'
import { validationSchemaFormVendor } from 'helpers/validation'

export default function VendorForm() {
  const { id } = useParams()

  const {
    statusForm,
    stateForm,
    banks,
    handleChangePageBanks,
    handleFetchOnCreate,
    handleFetchOnEdit,
    handleSubmit,
    initialForm,
    pageBanks,
    provincesAndCities,
    toastContainer,
    totalPageBanks,
  } = useVendors()

  useEffect(() => {
    if (id) {
      handleFetchOnEdit(id)
    } else {
      handleFetchOnCreate()
    }
  }, [id])

  const formik = useFormik({
    initialValues: initialForm,
    validateOnBlur: true,
    validationSchema: validationSchemaFormVendor,
    enableReinitialize: true,
    onSubmit: async values => {
      await handleSubmit(values)
    },
  })

  const isLoading = statusForm === 'loading'
  const labelButton = stateForm === 'create' ? 'Buat Vendor Baru' : 'Ubah Vendor'

  return (
    <div className="content-wrapper">
      {toastContainer}
      <Card className="bg-transparent p-0" loading={isLoading}>
        <div className="flex flex-col gap-4">
          <FormBasicInformation state={formik} helpers={formik} />
          <FormAddressInformation
            state={formik}
            helpers={formik}
            provincesAndCities={provincesAndCities}
          />
          <FormLegalityInformation
            state={formik}
            helpers={formik}
            banks={banks}
            pageBanks={pageBanks}
            totalPageBanks={totalPageBanks}
            onChangePageBanks={handleChangePageBanks}
          />
          <FormAdditionalInformation state={formik} helpers={formik} />
          <div className="flex w-2/12 self-end">
            <ButtonLink
              variant="solid-primary"
              block={true}
              label={labelButton}
              className="py-4 px-6 text-sm"
              onClick={formik.handleSubmit}
            />
          </div>
        </div>
      </Card>
    </div>
  )
}
